import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const AmmoniaAmmoniumIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBorder;
  return (
    <svg width="50px" height="44px" viewBox="0 0 50 44" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Assets-for-WWT" transform="translate(-1674, -129)">
          <g id="Group-26" transform="translate(1388, 105)">
            <g id="Ammonia/Ammonium_Connected" transform="translate(286, 24)">
              <text id="NH" fontFamily="Heebo-ExtraBold, Heebo" fontSize="16" fontWeight="700" fill={currentColor}>
                <tspan x="14" y="24">
                  NH
                </tspan>
              </text>
              <text id="3/4" fontFamily="Heebo-ExtraBold, Heebo" fontSize="10" fontWeight="700" fill={currentColor}>
                <tspan x="18" y="34">
                  3/4
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AmmoniaAmmoniumIcon;
